import { formatter } from "./formatter";
export var formatCurrency = function (value) {
    return formatter.toCurrency(value);
};
